import { EmailIntegration } from "@/schema"

type SendingAddressLike = { email?: string | null } | string | null | undefined

export function normalizeEmail(email: string | null | undefined) {
  return email?.trim().toLowerCase() || undefined
}

function sendingAddressEmail(address: SendingAddressLike) {
  return typeof address === "string" ? address : address?.email
}

/** Every address this integration can send from: its connected email plus any sending aliases. */
export function integrationSendingEmails(integration: EmailIntegration) {
  return [
    integration.connected_email,
    ...((integration.sending_addresses ?? []) as SendingAddressLike[]).map(sendingAddressEmail),
  ].filter((email): email is string => !!email)
}

/** Find the integration that can send from the given email, matching its connected email or any alias. */
export function findIntegrationForEmail(
  integrations: EmailIntegration[] | undefined,
  email: string | null | undefined
) {
  const normalized = normalizeEmail(email)
  if (!normalized) return undefined

  return integrations?.find((integration) =>
    integrationSendingEmails(integration).some((sendingEmail) => normalizeEmail(sendingEmail) === normalized)
  )
}
